// src/config/googleConfig.js
const googleConfig = {
  client_id: '39889276028-38rpvebrkh04eig1norems9rjs4o3p39.apps.googleusercontent.com',
  client_secret: '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',
  redirect_uris: ['http://localhost:3004'],
};

export default googleConfig;
